import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {deleteLoading, getCurrentLoading, resetDeleteLoadingStatus} from "../../store/reducers/LoadingsSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link} from "react-router-dom";

interface DeleteLoadingScreenProps {
}

export const DeleteLoadingScreen: React.FC<DeleteLoadingScreenProps> = () => {

    const {clientId, loadingId} = useParams();

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const loadingsState = useAppSelector((state) => state.loadings);
    const requestStatus: RequestStatus = loadingsState.deleteLoadingStatus;
    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Kliendid", url: "/clients"},
        {text: "Kliendi laadimised", url: `/clients/${clientId}/loadings`},
        {text: "Muuda laadimist", url: `/clients/${clientId}/loadings`},
    ];

    useEffect(() => {
        dispatch(resetDeleteLoadingStatus());
        if (loadingId) {
            dispatch(getCurrentLoading({id:loadingId}));
        }
    }, [id, location]);

    const handleConfirm = () => {
        if (loadingId) {
            dispatch(deleteLoading({id: loadingId}));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Laadimine soovitustest eemaldatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid laadimise soovitustest eemaldada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                <span>
                  <strong>Jah</strong>
                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};